export default (url, token, params) => {
    const time = new Date().getTime();
    const urlParams = Object.assign(params || {});
    urlParams.t = time;
    if (token) {
        urlParams.access_token = token;
    }
    const urlParamsStr = Object.entries(urlParams)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
    window.open(`${url}?${urlParamsStr}`);
};
